"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";

export default function LocaleSwitcher({ currentLocale, locales }) {
    const pathname = usePathname();
    function buildPath(nextLocale) {
        if (!pathname) return `/${nextLocale}`;
        const parts = pathname.split("/");
        if (parts.length < 2) return `/${nextLocale}`;
        parts[1] = nextLocale; // replace locale segment
        const nextPath = parts.join("/");
        return nextPath.endsWith("//") ? nextPath.slice(0, -1) : nextPath;
    }
    return (
        <div className="flex items-center gap-1">
            {locales.map((l) => (
                <Link
                    key={l}
                    href={buildPath(l)}
                    className={`px-3 py-2 min-h-[44px] min-w-[44px] flex items-center justify-center rounded-md transition-colors ${l === currentLocale
                        ? "font-semibold text-blue-700 bg-blue-50"
                        : "text-zinc-600 hover:text-blue-700 hover:bg-zinc-50"
                        }`}
                    aria-current={l === currentLocale ? "page" : undefined}
                    aria-label={`Switch to ${l.toUpperCase()} language`}
                >
                    {l.toUpperCase()}
                </Link>
            ))}
        </div>
    );
}



